/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { videoControllerCreate } from '../fn/video/video-controller-create';
import { VideoControllerCreate$Params } from '../fn/video/video-controller-create';
import { videoControllerDelete } from '../fn/video/video-controller-delete';
import { VideoControllerDelete$Params } from '../fn/video/video-controller-delete';
import { videoControllerFindAll } from '../fn/video/video-controller-find-all';
import { VideoControllerFindAll$Params } from '../fn/video/video-controller-find-all';
import { videoControllerFindById } from '../fn/video/video-controller-find-by-id';
import { VideoControllerFindById$Params } from '../fn/video/video-controller-find-by-id';
import { videoControllerSearchCursor } from '../fn/video/video-controller-search-cursor';
import { VideoControllerSearchCursor$Params } from '../fn/video/video-controller-search-cursor';
import { videoControllerSearchOffset } from '../fn/video/video-controller-search-offset';
import { VideoControllerSearchOffset$Params } from '../fn/video/video-controller-search-offset';
import { videoControllerUpdate } from '../fn/video/video-controller-update';
import { VideoControllerUpdate$Params } from '../fn/video/video-controller-update';
import { VideoDto } from '../models/video-dto';
import { VideoSearchResponseDto } from '../models/video-search-response-dto';

@Injectable({ providedIn: 'root' })
export class VideoService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `videoControllerFindAll()` */
  static readonly VideoControllerFindAllPath = '/api/videos';

  /**
   * 모든 비디오 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `videoControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  videoControllerFindAll$Response(params?: VideoControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VideoDto>>> {
    return videoControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 비디오 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `videoControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  videoControllerFindAll(params?: VideoControllerFindAll$Params, context?: HttpContext): Observable<Array<VideoDto>> {
    return this.videoControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<VideoDto>>): Array<VideoDto> => r.body)
    );
  }

  /** Path part for operation `videoControllerCreate()` */
  static readonly VideoControllerCreatePath = '/api/videos';

  /**
   * 비디오 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `videoControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  videoControllerCreate$Response(params: VideoControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<VideoDto>> {
    return videoControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 비디오 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `videoControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  videoControllerCreate(params: VideoControllerCreate$Params, context?: HttpContext): Observable<VideoDto> {
    return this.videoControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<VideoDto>): VideoDto => r.body)
    );
  }

  /** Path part for operation `videoControllerSearchOffset()` */
  static readonly VideoControllerSearchOffsetPath = '/api/videos/search/offset';

  /**
   * 비디오 오프셋 기반 조회.
   *
   * 비디오를 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `videoControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  videoControllerSearchOffset$Response(params: VideoControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<VideoSearchResponseDto>> {
    return videoControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 비디오 오프셋 기반 조회.
   *
   * 비디오를 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `videoControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  videoControllerSearchOffset(params: VideoControllerSearchOffset$Params, context?: HttpContext): Observable<VideoSearchResponseDto> {
    return this.videoControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<VideoSearchResponseDto>): VideoSearchResponseDto => r.body)
    );
  }

  /** Path part for operation `videoControllerSearchCursor()` */
  static readonly VideoControllerSearchCursorPath = '/api/videos/search/cursor';

  /**
   * 비디오 커서 기반 조회.
   *
   * 비디오를 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `videoControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  videoControllerSearchCursor$Response(params: VideoControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return videoControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 비디오 커서 기반 조회.
   *
   * 비디오를 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `videoControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  videoControllerSearchCursor(params: VideoControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.videoControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `videoControllerFindById()` */
  static readonly VideoControllerFindByIdPath = '/api/videos/{id}';

  /**
   * 비디오 ID 기반 조회.
   *
   * 비디오를 ID 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `videoControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  videoControllerFindById$Response(params: VideoControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<VideoDto>> {
    return videoControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 비디오 ID 기반 조회.
   *
   * 비디오를 ID 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `videoControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  videoControllerFindById(params: VideoControllerFindById$Params, context?: HttpContext): Observable<VideoDto> {
    return this.videoControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<VideoDto>): VideoDto => r.body)
    );
  }

  /** Path part for operation `videoControllerDelete()` */
  static readonly VideoControllerDeletePath = '/api/videos/{id}';

  /**
   * 비디오 삭제.
   *
   * 비디오를 삭제합니다
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `videoControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  videoControllerDelete$Response(params: VideoControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<VideoDto>> {
    return videoControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 비디오 삭제.
   *
   * 비디오를 삭제합니다
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `videoControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  videoControllerDelete(params: VideoControllerDelete$Params, context?: HttpContext): Observable<VideoDto> {
    return this.videoControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<VideoDto>): VideoDto => r.body)
    );
  }

  /** Path part for operation `videoControllerUpdate()` */
  static readonly VideoControllerUpdatePath = '/api/videos/{id}';

  /**
   * 비디오 수정.
   *
   * 비디오를 수정합니다
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `videoControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  videoControllerUpdate$Response(params: VideoControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<VideoDto>> {
    return videoControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 비디오 수정.
   *
   * 비디오를 수정합니다
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `videoControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  videoControllerUpdate(params: VideoControllerUpdate$Params, context?: HttpContext): Observable<VideoDto> {
    return this.videoControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<VideoDto>): VideoDto => r.body)
    );
  }

}
